import { FormApi } from 'final-form';
import { get, set } from 'lodash';
import Component from 'vue-class-component';

import { MediaTransferHelper } from '@skinsoft/media-transfer-helper';
import { ReactiveVue } from '@skinsoft/reactive-vue';

import { PRINCIPAL_IMAGE_CLICK_TOPIC, DELETE_IMAGE_CLICK_TOPIC, IMAGE_UPLOADED_TOPIC } from '../../../busTopics';
import { MediaArea } from '../fields-areas/medias-area';
import _ from 'lodash';
@Component({
    components: {
        sMediaArea: MediaArea
    },
    props: ["form", "fieldName", "entity"],
    template: require('./medias-fields-area.html')
})
export class MediasFieldsArea extends ReactiveVue {

    public fieldName: string;
    public entity: any;
    public form: FormApi;
    private $mediaTransferHelper: MediaTransferHelper;
    private mediaUploadInProgress: boolean = false;

    public mounted() {
        this.$on(IMAGE_UPLOADED_TOPIC, (fileData) => {
            this.uploadMedia(fileData)
        })

        this.$on(PRINCIPAL_IMAGE_CLICK_TOPIC, (mediaId) => {
            this.modifyFirstMedia(mediaId);
            this.$emit('imageChoice', mediaId)
        })

        this.$on('id-changed-from-cache',
            (message) => {
                this.updateMediaFromCacheChange(message.oldMediaId, message.newMediaId);
            })
    }

    public beforeDestroy() {
        this.$off(IMAGE_UPLOADED_TOPIC)
        this.$off(DELETE_IMAGE_CLICK_TOPIC)
        this.$off(PRINCIPAL_IMAGE_CLICK_TOPIC)
    }

    public get associatedMediasFieldName() {
        return `${this.fieldName}.medias`;
    }

    public get firstMediaFieldName() {
        return `${this.fieldName}.first`;
    }

    public get reportMedias() {
        let medias: any[] = this.form ? get(this.form.getState().values, this.associatedMediasFieldName ) : get(this.entity, this.associatedMediasFieldName);

        if (!medias) {
            medias = [];
            if(this.form){
                set(this.form.getState().values, this.associatedMediasFieldName, medias)
            }else{
                set(this.entity, this.associatedMediasFieldName, medias) 
            }
            return medias;
        }

        return medias
    }

    private onImageDeleteClick(event) {
        const medias = this.form ? get(this.form.getState().values, this.associatedMediasFieldName ) : get(this.entity, this.associatedMediasFieldName);
        if (medias) {
            const removedMediaId = medias.splice(event.imageListIndex, 1)
            const firstMedia = this.form ? get(this.form.getState().values, this.firstMediaFieldName ) : get(this.entity, this.firstMediaFieldName);
            if (removedMediaId === firstMedia) {
                this.modifyFirstMedia(null)
            }
        }
    }

    private modifyFirstMedia(mediaId) {
        if(this.form){
            set(this.form.getState().values, this.firstMediaFieldName, mediaId)
        }else{
            _.set(this.entity, this.firstMediaFieldName, mediaId) 
        }
    }

    private updateMediaFromCacheChange(oldMediaId, newMediaId) {
        let medias = this.form ? get(this.form.getState().values, this.associatedMediasFieldName ) : get(this.entity, this.associatedMediasFieldName);
        const index = medias.indexOf(oldMediaId)
        medias.splice(index, 1)
        medias.push(newMediaId)

        const firstMedia = this.form ? get(this.form.getState().values, this.firstMediaFieldName ) : get(this.entity, this.firstMediaFieldName);
        if (firstMedia === oldMediaId) {
            this.modifyFirstMedia(newMediaId)
        }

        // save report to keep modifications
        if(this.form){
            this.form.submit();
        }
    }

    private async uploadMedia(fileData) {
        const formData = new FormData();
        formData.append("file", fileData.file)

        let medias: any[] = this.form ? get(this.form.getState().values, this.associatedMediasFieldName ) : get(this.entity, this.associatedMediasFieldName);
        if (!medias) {
            medias = [];
        }
        this.mediaUploadInProgress = true;
        // Retrieving temp id and uploading the media on backend asynchronously
        const mediaId = await this.$mediaTransferHelper.uploadMedia(fileData.file.type, fileData.file, fileData.url);
        this.mediaUploadInProgress = false;

        medias.push(mediaId);
        this.$emit('addMedia', { mediaId: mediaId })
    }
}